import React from "react";
import closeIcon from "../../img/closeIcon.svg";

const CargoCaseCancelCreateModal = (props) => {

    const {
        closeModal
    } = props;

    return (
        <div className="cargo-case-cancel-create-modal__container">
            <div className="cargo-case-cancel-create-modal">
                <div className="cargo-case-cancel-create-modal__title">
                    <h3 className="cargo-case-cancel-create-modal__title-name">
                        Are you sure you want to cancel the creation of the Сargo case?
                    </h3>
                    <img onClick={closeModal} className="cargo-case-cancel-create-modal__title-icon" src={closeIcon} alt={'иконка крестик'}/>
                </div>
                <p className="cargo-case-cancel-create-modal__text">
                    The entered data will not be saved. You can save data as a draft
                </p>
                <div className="cargo-case-cancel-create-modal__buttons">
                    <button onClick={closeModal} className="cargo-case-cancel-create-modal__dont-save-btn">Don’t save</button>
                    <button className="cargo-case-cancel-create-modal__save-btn">Save</button>
                </div>
            </div>
        </div>
    )
}
export default CargoCaseCancelCreateModal;